import React from "react";
import {
  Autocomplete,
  Box,
  CircularProgress,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import SelectorFiltrosMultiples from "../../agregados/SelectorFiltrosMultiples";
import ChipsFiltrosActivos from "../../agregados/ChipsFiltrosActivos";

const estiloBotonAccion = {
  width: 36,
  height: 36,
  border: "1px solid",
  borderColor: "grey.300",
  backgroundColor: "white",
};

// Buscador de direcciones con filtros, botón de alta de cliente y de
// coordenadas, y chips de filtros activos.
export default function BuscadorDireccion({
  filtrosSeleccionados,
  onFiltrosChange,
  inputValue,
  onInputChange,
  opciones,
  loading,
  placeholder,
  value,
  onChange,
  onClickNuevoCliente,
  mostrarAgregarCoordenadas,
  onClickAgregarCoordenadas,
}) {
  return (
    <Grid item xs={12}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={12} sm="auto">
            <Box sx={{ minWidth: 160, height: 40 }}>
              <SelectorFiltrosMultiples
                filtrosSeleccionados={filtrosSeleccionados}
                onFiltrosChange={onFiltrosChange}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm>
            <Autocomplete
              loading={loading}
              required
              disableClearable
              inputValue={inputValue}
              id="buscar-direccion"
              size="small"
              loadingText="Buscando..."
              noOptionsText={
                inputValue.length < 2
                  ? "Escriba al menos 2 caracteres..."
                  : filtrosSeleccionados.length === 0
                    ? "Seleccione al menos un filtro"
                    : loading
                      ? "Buscando..."
                      : "No se encontraron resultados"
              }
              options={opciones}
              autoHighlight
              filterOptions={(options) => options}
              getOptionLabel={(direccion) =>
                direccion
                  ? `${direccion.direccion_entrega} - ${direccion?.localidad}`
                  : ""
              }
              isOptionEqualToValue={(option, val) => option?.id === val?.id}
              value={value}
              onChange={(event, newValue) => onChange(newValue)}
              onInputChange={(event, newInputValue) => onInputChange(newInputValue)}
              renderOption={(props, option) => (
                <Box component="li" {...props} sx={{ py: 1.5 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <Box
                      sx={{
                        width: 6,
                        height: 6,
                        borderRadius: "50%",
                        backgroundColor: "primary.main",
                        flexShrink: 0,
                      }}
                    />
                    <Box sx={{ minWidth: 0, flex: 1 }}>
                      <Typography variant="subtitle2" fontWeight="600" noWrap>
                        {option.nombre_direccion} - {option.direccion_entrega}
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}>
                        <Typography variant="caption" color="text.secondary">
                          {option.localidad}
                        </Typography>
                        <Box
                          sx={{
                            width: 3,
                            height: 3,
                            borderRadius: "50%",
                            backgroundColor: "grey.400",
                          }}
                        />
                        <Typography variant="caption" color="text.primary" fontWeight="500">
                          {option.razon_social}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={placeholder}
                  label="Buscar"
                  size="small"
                  error={filtrosSeleccionados.length === 0}
                  helperText={
                    filtrosSeleccionados.length === 0 ? "Seleccione al menos un filtro" : ""
                  }
                  sx={{ "& .MuiOutlinedInput-root": { height: 40 } }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loading ? <CircularProgress color="inherit" size={16} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm="auto">
            <Box
              sx={{
                display: "flex",
                gap: 0.5,
                height: 40,
                alignItems: "center",
                justifyContent: { xs: "flex-start", sm: "flex-end" },
              }}
            >
              <Tooltip title="Agregar Cliente">
                <IconButton size="small" onClick={onClickNuevoCliente} sx={estiloBotonAccion}>
                  <PersonAddAltIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              {mostrarAgregarCoordenadas && (
                <Tooltip title="Agregar coordenadas">
                  <IconButton
                    size="small"
                    onClick={onClickAgregarCoordenadas}
                    sx={estiloBotonAccion}
                  >
                    <AddLocationAltIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          </Grid>
        </Grid>

        <ChipsFiltrosActivos
          filtrosSeleccionados={filtrosSeleccionados}
          onFiltrosChange={onFiltrosChange}
        />
      </Box>
    </Grid>
  );
}
